var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{ref:"tree",staticClass:"folders-only",attrs:{"multiple":false,"clearable":false,"searchable":true,"always-open":true,"default-expand-level":Infinity,"max-height":99999,"load-options":_vm.loadOptions,"options":_vm.options,"placeholder":"Filter..."},on:{"input":(val) => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }